import { AslibModalComponent, AslibModalDismissReasons } from '@aslib/modal';
import { ModalManagerModel } from './model/modal-manager.model';

export type typeModal = 'error' | 'danger' | 'success' | 'warning' | 'question' | 'info' | 'default';

export class ModalManagerHelper {
  public parent: any = null;
  public metodoPergunta: any = null;
  modalManager = new ModalManagerModel();

  constructor() { }

  public modalOption(

    modal: AslibModalComponent,
    modalManager: ModalManagerModel,
    _type: typeModal
  ) {

    modal.text = modalManager.Text;
    modal.type = _type;
    modal.title = modalManager.Title;
    modal.backdrop = modalManager.Backdrop;
    modal.cancelarVisible = modalManager.CancelarVisible;
    modal.okText = modalManager.OkText;
    modal.cancelarText = modalManager.CancelarText;
  }

  public modalOptionSucesso(modal: AslibModalComponent, _mensagemSucesso: string) {
    this.modalManager.CancelarVisible = false;
    this.modalManager.Text = _mensagemSucesso;
    this.modalManager.Title = 'Sucesso';
    this.modalManager.OkText = 'Ok';
    this.modalManager.Backdrop = 'static';
    this.modalManager.OkText = 'Ok';
    this.modalOption(modal, this.modalManager, 'success');
  }

  public modalOptionAlerta(modal: AslibModalComponent, _mensagemAlerta: string) {
    this.modalManager.CancelarVisible = false;
    this.modalManager.Text = _mensagemAlerta;
    this.modalManager.Title = 'Alerta';
    this.modalManager.OkText = 'Ok';
    this.modalManager.Backdrop = 'static';
    this.modalManager.OkText = 'Ok';
    this.modalOption(modal, this.modalManager, 'warning');
  }
  public modalSucessoFunc(modal: AslibModalComponent, func: () => void, _mensagem: string) {
    this.modalOptionSucesso(modal, _mensagem);
    this.modalOpenFunc(modal, () => func());
  }
  public modalSucesso(modal: AslibModalComponent, _rotaNavegarPagina: string, _mensagem: string) {
    this.modalOptionSucesso(modal, _mensagem);
    this.modalOpen(modal, _rotaNavegarPagina);
  }

  public modalAlerta(modal: AslibModalComponent, _mensagem: string) {
    if (_mensagem !== undefined) {
      this.modalOptionAlerta(modal, _mensagem);
      this.modalOpen(modal, '');
    }
  }

  public modalErroRota(modal: AslibModalComponent, _rotaNavegarPagina: string, _mensagem: string) {
    this.modalManager.CancelarVisible = false;
    this.modalManager.Text = _mensagem;
    this.modalManager.Title = 'Atenção';
    this.modalManager.OkText = 'Ok';
    this.modalManager.Backdrop = 'static';
    this.modalManager.OkText = 'Ok';
    this.modalOption(modal, this.modalManager, 'warning');
    this.modalOpen(modal, _rotaNavegarPagina);
  }

  public modalErro(modal: AslibModalComponent, _mensagem: string) {
    if (_mensagem !== undefined) {
      this.modalManager.CancelarVisible = false;
      this.modalManager.Text = _mensagem;
      this.modalManager.Title = 'Atenção';
      this.modalManager.OkText = 'Ok';
      this.modalManager.Backdrop = 'static';
      this.modalManager.OkText = 'Ok';
      this.modalOption(modal, this.modalManager, 'warning');
      this.modalOpen(modal, '');
    }
  }

  public modalDeletar(modal: AslibModalComponent, _item: any, _mensagem = 'Tem certeza que deseja excluir?') {
    this.modalManager.Text = _mensagem;
    this.modalManager.Title = 'Confirmação';
    this.modalManager.Backdrop = 'static';
    this.modalManager.CancelarVisible = true;
    this.modalManager.OkText = 'Sim';
    this.modalManager.CancelarText = 'Não';
    this.modalOption(modal, this.modalManager, 'warning');

    modal.open().result.then(
      result => {
        if (AslibModalDismissReasons[result] === 'OK') {
          this.parent.deletar(_item, modal);
        }
      },
      reason => { }
    );
  }

  public modalpergunta(modal: AslibModalComponent, _item: any, mensagemObjeto: any, _okText = 'Sim', _cancelarText = 'Não') {

      if (mensagemObjeto === undefined || mensagemObjeto.Mensagem === undefined) {
        return;
      }

      const tipoPadrao: typeModal = 'question';
      const tituloPadrao = 'Atenção';
    
      let tipo: typeModal;
      let titulo: string;
      let mensagem: string;

      tipo = mensagemObjeto.Tipo;
      titulo = mensagemObjeto.Titulo;
      mensagem = mensagemObjeto.Mensagem;   

      if (titulo === '') {
        tipo = tipoPadrao;
        titulo = tituloPadrao;
      }

    this.modalManager.Text = mensagem;
    this.modalManager.Title = 'Confirmação';
    this.modalManager.Backdrop = 'static';
    this.modalManager.CancelarVisible = true;
    this.modalManager.OkText = _okText;
    this.modalManager.CancelarText = _cancelarText;
    this.modalOption(modal, this.modalManager, 'warning');
  }

  private modalOpen(modal: AslibModalComponent, _rotaNavegarPagina: string) {
    if (_rotaNavegarPagina !== '') {
      modal.open().result.then(
        result => {
          this.navegarPagina(_rotaNavegarPagina);
        },
        reason => {
          this.navegarPagina(_rotaNavegarPagina);
        }
      );
    } else {
      modal.open();
    }
  }
  private modalOpenFunc(modal: AslibModalComponent, func: () => void) {
    modal.open().result.then(
      result => {
        func();
      },
      reason => {
        func();
      }
    );
  }
  private navegarPagina(_rota: string) {
    if (_rota !== '') {
      this.parent.navegarPagina(_rota);
    }
  }
  public modalError(modal) {
    const mensagemErro = 'Não foi possível se comunicar com o servidor, entre em contato com o administrador do sistema.';

    this.modalManager.OkText = 'Ok';
    this.modalManager.CancelarVisible = false;
    this.modalManager.Text = mensagemErro;
    this.modalManager.Title = 'Erro';
    this.modalManager.Backdrop = 'static';
    this.modalOption(modal, this.modalManager, 'error');
    this.modalOpen(modal, '');
  }
  public modalMensagem(modal: AslibModalComponent, mensagemObjeto: any, redirecionar = '') {
    const tipoPadrao: typeModal = 'warning';
    const tituloPadrao = 'Atenção';
  
    let tipo: typeModal;
    let titulo: string;
    let mensagem: string;

    

    if (mensagemObjeto === undefined || mensagemObjeto.Mensagem === undefined) {
      return;
    }

    tipo = mensagemObjeto.Tipo;
    titulo = mensagemObjeto.Titulo;
    mensagem = mensagemObjeto.Mensagem;   

    if (titulo === '') {
      tipo = tipoPadrao;
      titulo = tituloPadrao;
    }

    this.modalManager.OkText = 'Ok';
    this.modalManager.CancelarVisible = false;
    this.modalManager.Text = mensagem;
    this.modalManager.Title = titulo;
    this.modalManager.Backdrop = 'static';
    this.modalOption(modal, this.modalManager, tipo);
    this.modalOpen(modal, '');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/modal-manager-helper.ts